/**
 * main.js — RHINO site runtime (bundled by esbuild → public/js/main.js)
 *
 *   modules/core.js      flags (reduced motion, pointer), Lenis smooth scroll, in-page links, runtime strings
 *   modules/hero.js      FIG. 01 — pinned scroll assembly; lazy-loads hero3d.js (three.js) on capable devices
 *   modules/sections.js  nav + mobile menu, reveals, the menu page filters, consultancy services, coaster colour picker, cursor
 *   modules/form.js      home contact form (Netlify Forms "contact")
 *   modules/builder.js   calculators on the service pages (Netlify Forms "aanvraag-<page>")
 * Every module checks that its markup exists, so the thank-you / 404 pages can load the same bundle.
 */
import { initHero } from "./modules/hero.js";
import { initNav, initReveal, initMenu, initCoasters, initCursor, initGallery, initServices, forwardLegacyAnchors } from "./modules/sections.js";
import { initForm } from "./modules/form.js";
import { initBuilder } from "./modules/builder.js";

forwardLegacyAnchors();

// each init is timed (performance.measure "rhino:<name>") — visible in DevTools › Performance › Timings
const timed = (name, fn) => { const t = performance.now(); const r = fn(); performance.measure(`rhino:${name}`, { start: t }); return r; };
timed("nav", initNav);
const hero = timed("hero", initHero);
timed("reveal", initReveal);
timed("menu", initMenu);
timed("coasters", initCoasters);
timed("form", initForm);
timed("builder", initBuilder);
timed("gallery", initGallery);
timed("services", initServices);
timed("cursor", () => initCursor(hero));
// date fields (contact form + calculators): no dates in the past
const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
document.querySelectorAll('input[type="date"]').forEach((i) => (i.min = today));
const yr = document.getElementById("yr");
if (yr) yr.textContent = new Date().getFullYear();
